import {moment} from 'helpers';

let noise = 0;

export function generate() {
  return (moment().valueOf() + (noise++ % 100)).toString();
}
